/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskReportsHomePageType from '@jira/spa-apps__servicedesk-reports-home-page/src/ReportsHomePage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import { HOME_PAGE_SUFFIX } from '../../common/constants.tsx';

export const LazyServicedeskReportsHomePage: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ServicedeskReportsHomePageType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-reports-home-page", jiraSpaEntry: "async-servicedesk-reports-workload" */ '@jira/spa-apps__servicedesk-reports-home-page/src/ReportsHomePage.tsx'
		),
	),
);

const AsyncServicedeskReportsHomePage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskReportsHomePage}
		pageId={`spa-apps/servicedesk${HOME_PAGE_SUFFIX}}`}
		shouldShowSpinner
	/>
);

export default AsyncServicedeskReportsHomePage;
